.cardPositive {
  background:
    linear-gradient(
      90deg,
      var(--background-soft) 0%,
      color-mix(in srgb, var(--surface-success) 50%, transparent) 100%
    ),
    var(--background-soft);
}

.cardNegative {
  background:
    linear-gradient(
      90deg,
      var(--background-soft) 0%,
      color-mix(in srgb, var(--surface-critical) 50%, transparent) 100%
    ),
    var(--background-soft);
}

.cardWarning {
  background:
    linear-gradient(
      90deg,
      var(--background-soft) 0%,
      color-mix(in srgb, var(--surface-warning) 50%, transparent) 100%
    ),
    var(--background-soft);
}

.warning {
  color: var(--text-warning);
}

.themeFillIndustry {
  background-color: var(--kg-theme);
  color: var(--text-default);
}

.themeFillFinancial {
  background-color: var(--icon-decorative-purple);
  color: var(--text-inverse);
}

.themeFillMacro {
  background-color: var(--icon-decorative-teal);
  color: var(--text-inverse);
}
